/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { Icon } from './icon';
// May contain unused imports in some cases
// @ts-ignore
import type { PublishedNavigationElementChildrenInner } from './published-navigation-element-children-inner';

/**
 * 
 * @export
 * @interface PublishedNavigationElement
 */
export interface PublishedNavigationElement {
    /**
     * 
     * @type {string}
     * @memberof PublishedNavigationElement
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PublishedNavigationElement
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof PublishedNavigationElement
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PublishedNavigationElement
     */
    'type': PublishedNavigationElementTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PublishedNavigationElement
     */
    'page_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishedNavigationElement
     */
    'parent_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishedNavigationElement
     */
    'full_path': string;
    /**
     * 
     * @type {Icon}
     * @memberof PublishedNavigationElement
     */
    'icon'?: Icon;
    /**
     * 
     * @type {Array<PublishedNavigationElementChildrenInner>}
     * @memberof PublishedNavigationElement
     */
    'children'?: Array<PublishedNavigationElementChildrenInner>;
}

export const PublishedNavigationElementTypeEnum = {
    Folder: 'folder',
    MaritimeWarningsPage: 'maritime_warnings_page',
    Page: 'page',
    PublicWarningsPage: 'public_warnings_page'
} as const;

export type PublishedNavigationElementTypeEnum = typeof PublishedNavigationElementTypeEnum[keyof typeof PublishedNavigationElementTypeEnum];


